import * as constants from '../constants/training_matrix'

const defaultState = {
  matrices: [],
  matrix: [],
  trainee: {},
  complianceRatings: [],
  complianceHistory: [],
  requestSuccess: false,
  requestType: '',
  isInitial: false,
  deleteTraineeSuccess: false,
  managers: [],
  training_record: {}
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case constants.GET_MATRICES_REQUEST:
      newState.requestType = constants.GET_MATRICES_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_MATRICES_SUCCESS:
      newState.matrices = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_MATRICES_FAILURE:
      newState = defaultState;
      return newState;
    case constants.CREATE_MATRIX_REQUEST:
      newState.requestType = constants.CREATE_MATRIX_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.CREATE_MATRIX_SUCCESS:
      newState.matrix = action.body;
      newState.managers = action.body.managers;
      newState.requestSuccess = true;
      return newState;
    case constants.CREATE_MATRIX_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_MATRIX_REQUEST:
      newState.requestType = constants.GET_MATRIX_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_MATRIX_SUCCESS:
      newState.requestType = constants.GET_MATRIX_REQUEST;
      newState.matrix = action.body;
      newState.managers = action.body.managers;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_MATRIX_FAILURE:
      newState = defaultState;
      return newState;
    case constants.UPDATE_MATRIX_REQUEST:
      newState.requestType = constants.UPDATE_MATRIX_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UPDATE_MATRIX_SUCCESS:
      newState.requestSuccess = true;
      newState.managers = action.body.managers;
      return newState;
    case constants.UPDATE_MATRIX_FAILURE:
      newState = defaultState;
      return newState;
    case constants.ADD_TRAINEE_REQUEST:
      newState.requestType = constants.ADD_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.ADD_TRAINEE_SUCCESS:
      newState.trainee = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.ADD_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.CREATE_MODULE_REQUEST:
      newState.requestType = constants.CREATE_MODULE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.CREATE_MODULE_SUCCESS:
      newState.requestSuccess = true;
      return newState;
    case constants.CREATE_MODULE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_REQUEST:
      newState.requestType = constants.GET_COMPLIANCE_RATINGS_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_SUCCESS:
      newState.requestType = constants.GET_COMPLIANCE_RATINGS_REQUEST;
      newState.complianceRatings = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_FAILURE:
      newState = defaultState;
      return newState;
    case constants.UPDATE_MODULE_REQUEST:
      newState.requestType = constants.UPDATE_MODULE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UPDATE_MODULE_SUCCESS:
      newState.requestSuccess = true;
      newState.trainee = action.body;
      return newState;
    case constants.UPDATE_MODULE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.EDIT_MODULE_REQUEST:
      newState.requestType = constants.EDIT_MODULE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.EDIT_MODULE_SUCCESS:
      newState.requestSuccess = true;
      newState.matrix = action.body;
      return newState;
    case constants.EDIT_MODULE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_COMPLIANCE_HISTORY_REQUEST:
      newState.requestType = constants.GET_COMPLIANCE_HISTORY_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_COMPLIANCE_HISTORY_SUCCESS:
      newState.requestType = constants.GET_COMPLIANCE_HISTORY_REQUEST;
      newState.complianceHistory = action.body;
      newState.requestSuccess = true;
      newState.isInitial = action.isInitial;
      return newState;
    case constants.GET_COMPLIANCE_HISTORY_FAILURE:
      newState = defaultState;
      return newState;
    case constants.DELETE_TRAINEE_REQUEST:
      newState.requestType = constants.DELETE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.DELETE_TRAINEE_SUCCESS:
      newState.deleteTraineeSuccess = action.body.result;
      newState.requestSuccess = true;
      return newState;
    case constants.DELETE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.ARCHIVE_TRAINEE_REQUEST:
      newState.requestType = constants.ARCHIVE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.ARCHIVE_TRAINEE_SUCCESS:
      newState.requestSuccess = action.body.result;
      return newState;
    case constants.ARCHIVE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState
    case constants.UNARCHIVE_TRAINEE_REQUEST:
      newState.requestType = constants.UNARCHIVE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UNARCHIVE_TRAINEE_SUCCESS:
      newState.requestSuccess = action.body.result;
      return newState;
    case constants.UNARCHIVE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.UPDATE_TRAINING_RECORD_REQUEST:
      newState.requestType = constants.UPDATE_TRAINING_RECORD_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UPDATE_TRAINING_RECORD_SUCCESS:
      newState.requestSuccess = true;
      newState.training_record = action.body;
      return newState;
    case constants.UPDATE_TRAINING_RECORD_FAILURE:
      newState = defaultState;
      return newState;
    case constants.UPDATE_TRAINEE_REQUEST:
      newState.requestType = constants.UPDATE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UPDATE_TRAINEE_SUCCESS:
      newState.requestSuccess = true;
      newState.trainee = action.body;
      return newState;
    case constants.UPDATE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.CLEAR_UPDATE:
      newState.requestType = '';
      newState.requestSuccess = false;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/training_matrix.js